import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedInfoNotice = _resolveComponent("SharedInfoNotice")!
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_UITextArea = _resolveComponent("UITextArea")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SettingsRequisitesVerification = _resolveComponent("SettingsRequisitesVerification")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('header-title'))
        }, _toDisplayString(_ctx.$t("Банковские реквизиты")), 3)
      ], 2),
      _createVNode(_component_SharedInfoNotice, {
        class: _normalizeClass(_ctx.b('info'))
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("Это реквизиты для пополнения и вывода фиата.")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(
            "С этого счёта вы пополняете баланс, на него же уходят выводы — поэтому счёт должен принадлежать вам."
          )), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(
            "Если какого-то поля у вашего банка нет, поставьте прочерк «—». Реквизиты проходят проверку, обычно в течение рабочего дня."
          )), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('form'))
      }, [
        _createVNode(_component_SharedValidate, {
          field: "name",
          value: _ctx.requisitesBankRequest.name,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.name,
          "onUpdate:fieldValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requisitesBankFields.name) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Название*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requisitesBankRequest.name) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-group'))
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('form-group'))
        }, null, 2),
        _createVNode(_component_SharedValidate, {
          field: "account_number",
          value: _ctx.requisitesBankRequest.account_number,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.account_number,
          "onUpdate:fieldValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requisitesBankFields.account_number) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Номер расчетного счета*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.account_number,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requisitesBankRequest.account_number) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createVNode(_component_SharedValidate, {
          field: "correspondent_account",
          value: _ctx.requisitesBankRequest.correspondent_account,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.correspondent_account,
          "onUpdate:fieldValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requisitesBankFields.correspondent_account) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Номер корреспондентского счета*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.correspondent_account,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requisitesBankRequest.correspondent_account) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createVNode(_component_SharedValidate, {
          field: "bank_identification_code",
          value: _ctx.requisitesBankRequest.bank_identification_code,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.bank_identification_code,
          "onUpdate:fieldValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requisitesBankFields.bank_identification_code) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Банковский идентификационный код (БИК)*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.bank_identification_code,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requisitesBankRequest.bank_identification_code) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createVNode(_component_SharedValidate, {
          field: "bank_name",
          value: _ctx.requisitesBankRequest.bank_name,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.bank_name,
          "onUpdate:fieldValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requisitesBankFields.bank_name) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Полное наименование банка*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.bank_name,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requisitesBankRequest.bank_name) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createVNode(_component_SharedValidate, {
          field: "inn",
          value: _ctx.requisitesBankRequest.inn,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.inn,
          "onUpdate:fieldValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requisitesBankFields.inn) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("Идентификационный номер")) + " ", 1),
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("налогоплательщика (ИНН)*")), 1)
              ], 2),
              _createVNode(_component_UIInput, {
                view: "light",
                modelValue: _ctx.requisitesBankRequest.inn,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requisitesBankRequest.inn) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"]),
        _createVNode(_component_SharedValidate, {
          field: "registration_reason_code",
          value: _ctx.requisitesBankRequest.registration_reason_code,
          "is-validate": _ctx.isValidate,
          "is-absolute": true,
          "field-value": _ctx.requisitesBankFields.registration_reason_code,
          "onUpdate:fieldValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requisitesBankFields.registration_reason_code) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('form-group'))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass(_ctx.b('form-title'))
              }, _toDisplayString(_ctx.$t("Код причины постановки на учет (КПП)*")), 3),
              _createVNode(_component_UIInput, {
                view: "light",
                placeholder: "—",
                "placeholder-view": "light",
                modelValue: _ctx.requisitesBankRequest.registration_reason_code,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requisitesBankRequest.registration_reason_code) = $event))
              }, null, 8, ["modelValue"])
            ], 2)
          ]),
          _: 1
        }, 8, ["value", "is-validate", "field-value"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('note'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('note-title'))
        }, _toDisplayString(_ctx.$t("Комментарий")), 3),
        _createVNode(_component_UITextArea, {
          view: "light",
          placeholder: "Например: назначение платежа или адрес банка",
          "placeholder-view": "light",
          modelValue: _ctx.requisitesBankRequest.note,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requisitesBankRequest.note) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('note-description'))
        }, _toDisplayString(_ctx.$t(
            "Необязательно. Передаём текст в назначение перевода, если это возможно."
          )), 3)
      ], 2),
      _createVNode(_component_UIButton, {
        class: _normalizeClass(_ctx.b('confirm')),
        label: "Подтвердить",
        view: "main",
        disabled: _ctx.isContinueDisabled,
        onClick: _ctx.handleContinue
      }, null, 8, ["class", "disabled", "onClick"]),
      _createVNode(_Transition, { name: "opacity" }, {
        default: _withCtx(() => [
          (_ctx.isVerification)
            ? (_openBlock(), _createBlock(_component_SettingsRequisitesVerification, {
                key: 0,
                class: _normalizeClass(_ctx.b('modal')),
                type: "bank-requisite",
                onClose: _ctx.handleVerificationClose
              }, null, 8, ["class", "onClose"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}